import { render, staticRenderFns } from "./SessionScore.Component.vue?vue&type=template&id=65e19fce&scoped=true&"
import script from "./SessionScore.Component.vue?vue&type=script&lang=ts&"
export * from "./SessionScore.Component.vue?vue&type=script&lang=ts&"
import style0 from "./SessionScore.Component.vue?vue&type=style&index=0&id=65e19fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e19fce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
